// extracted by mini-css-extract-plugin
export default {"carousel":"RelatedProducts_carousel__CWutE","tittle":"RelatedProducts_tittle__7Qzum","description":"RelatedProducts_description__yT-9S"};